import { useState } from 'react'

import { Loader } from '@giphy/react-components'
import { useTranslation } from 'react-i18next'
import { type StepWizardChildProps } from 'react-step-wizard'
import styled from 'styled-components'

import { useCountryMutation } from 'api/verification'
import { Checkbox } from 'components-ref/atoms'
import { VerificationCountryForm } from 'components-ref/organisms/verification/VerificationCountryForm/VerificationCountryForm'
import { VerificationFooter } from 'components-ref/organisms/verification/VerificationFooter/VerificationFooter'
import { useUserProfile } from 'store'
import colors from 'styles/colors'
import { type Country } from 'types/api/country'

export function VerificationCountry({
    currentStep,
    previousStep,
    nextStep
}: Partial<StepWizardChildProps>) {
    const userData = useUserProfile()
    const { t } = useTranslation()
    const [confirmation, setConfirmation] = useState(false)
    const [selectedCountry, setSelectedCountry] = useState<Country | null>(null)
    const { countryMutation } = useCountryMutation({ nextStep })
    function handleNextStep() {
        if (selectedCountry) countryMutation.mutate(selectedCountry.id)
        else nextStep?.()
    }
    if (!userData) return <Loader />
    return (
        <VerificationContainer>
            <CountryWrapper>
                <VerificationCountryForm
                    selectedCountry={selectedCountry}
                    setSelectedCountry={setSelectedCountry}
                />
                <CheckboxContainer>
                    <Checkbox
                        id='18-check'
                        label={
                            <CheckboxText>
                                {t('confirmThatYouAreAtLeast18')}
                            </CheckboxText>
                        }
                        value={'confirmation'}
                        checked={confirmation}
                        handleOnChange={() => {
                            setConfirmation(!confirmation)
                        }}
                    />
                </CheckboxContainer>
            </CountryWrapper>
            <VerificationFooter
                currentStep={currentStep}
                previousStep={previousStep}
                nextStep={handleNextStep}
                nextDisabled={
                    (!selectedCountry && !userData.country) || !confirmation
                }
            />
        </VerificationContainer>
    )
}

const CountryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const VerificationContainer = styled.div`
    min-height: 100%;
    padding: 4rem 2rem;
    padding-top:0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`

const CheckboxContainer = styled.div`
    width: 100%;
    display: flex;
    padding: 2rem;
`

const CheckboxText = styled.div`
    font-size: 1.4rem;
    color: ${colors.grey};
`
